import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "header"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "srOnly" }
const _hoisted_4 = {
  key: 0,
  role: "img",
  "aria-hidden": "true",
  alt: "Arrow icon seperating the ports",
  width: "20",
  height: "8",
  viewBox: "0 0 20 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = {
  key: 0,
  class: "portInfo location"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "portInfo routeCode" }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = {
  key: 0,
  role: "img",
  "aria-hidden": "true",
  width: "20",
  height: "8",
  viewBox: "0 0 20 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

import { computed } from 'vue';
import { Skeletor } from 'vue-skeletor';
import { IconText } from '..';
import { Icon } from '../../Atoms/index';
import { Port } from '../../types';
import 'vue-skeletor/dist/vue-skeletor.css';


export default /*@__PURE__*/_defineComponent({
  __name: 'PortList',
  props: {
    ports: {},
    iconName: {},
    showPortLocation: { type: Boolean },
    isLoading: { type: Boolean, default: false },
    textCode: { default: '' },
    showTextCode: { type: Boolean, default: false },
    destinationName: {}
  },
  setup(__props: any) {

const props = __props;

const displayTextCode = computed(() => props.showTextCode && props.textCode && !props.isLoading);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["portList", { portListIcon: _ctx.iconName}])
  }, [
    (_ctx.iconName)
      ? (_openBlock(), _createBlock(_unref(Icon), {
          key: 0,
          "icon-name": _ctx.iconName,
          md: true
        }, null, 8, ["icon-name"]))
      : _createCommentVNode("", true),
    (_ctx.destinationName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(IconText), {
            text: _ctx.destinationName,
            "icon-name": "mapPin",
            "icon-md": true,
            "is-loading": _ctx.isLoading
          }, null, 8, ["text", "is-loading"]),
          _renderSlot(_ctx.$slots, "favourite")
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.ports?.length)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 2,
          "aria-label": _ctx.ports.length >= 2
        ? `Route from ${_ctx.ports[0].name} ${_ctx.ports.length > 2 ? 'via ' + _ctx.ports.slice(1, _ctx.ports.length - 1).map(p => p.name).join(', ') + ' ' : ''}to ${_ctx.ports[_ctx.ports.length - 1].name}`
        : ''
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.ports.length >= 2
            ? `Route from ${_ctx.ports[0].name} ${
              _ctx.ports.length > 2
                ? 'via ' + _ctx.ports.slice(1, _ctx.ports.length - 1).map(p => p.name).join(', ') + ' '
                : ''
            }to ${_ctx.ports[_ctx.ports.length - 1].name}`
            : _ctx.ports.length === 1
              ? `Route to ${_ctx.ports[0].name}`
              : 'Route unavailable'), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ports, (port, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: _normalizeClass({ hasCode: port.location })
            }, [
              (index > 0)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _cache[0] || (_cache[0] = [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M13.25 7.79423L20 3.89711L13.25 0V3.39711H0V4.39711H13.25V7.79423Z",
                      fill: "black"
                    }, null, -1)
                  ])))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(port.name) + " ", 1),
                (_ctx.showPortLocation && port.location)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(port.location), 1))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          }), 128)),
          (displayTextCode.value)
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, " : " + _toDisplayString(_ctx.$t('Text code')) + " " + _toDisplayString(_ctx.textCode), 1)
              ]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (x, index) => {
            return _createElementVNode("li", { key: index }, [
              (index > 0)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _cache[1] || (_cache[1] = [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M13.25 7.79423L20 3.89711L13.25 0V3.39711H0V4.39711H13.25V7.79423Z",
                      fill: "black"
                    }, null, -1)
                  ])))
                : _createCommentVNode("", true),
              _createVNode(_unref(Skeletor), {
                class: "portSkeleton",
                height: "30"
              })
            ])
          }), 64))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})